import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material"
import { useStyles } from "./styles"
import { useTranslation } from "react-i18next"
import { BaseMenu, BreadCrumb, CustomTable, SnackSimple } from "../../../../../../components"
import { ModelDownloadButtons } from "../../../../../../components/donwloadFiles/model"
import { icons } from "../../../../../../utils/icons"
import { useContext, useEffect } from "react"
import { UserGroupContext } from "../../context"
import { FiltersDrawer } from "../../../../../../components/filtersDrawer"
import { DinamicForm } from "../../../../../../components/dinamicForm"
import { useTable } from "./hooks/table"
import { Item } from "../../../../../../utils/types/generals"
import SimpleModal from "../../../../../../components/modal/simpleModal"
import { useNavigate } from "react-router-dom"
import { useDownloadWithUuid } from "../../../../../../hooks/download/useDpwnloadWithUuid"
import { Types } from "../../../../../../utils/enums"
import { userGroupServiceFetch } from "../../../../../../utils/constants/callService"
import { returnQueryWithPagination } from "../../../../../../utils/methods/returnQuery"
import { formatFilterMain } from "../../constans"
import { LinearProgressDownload } from "../../../../../logbook/pages/main/components/shared/actionsTabs/linearProgressDownload"


export const UserGroup = () => {

    const styles = useStyles()
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { filterMainData, fitlerMain, isChecked, notGroupSelected, selectedIds, setIsChecked, setNotGroupSelected, setSelectedIds, setUuid, uuid } = useContext(UserGroupContext);
    const { cleanFilter, counter, errors, filterData, onChange, handlePagination, query, sortTable, paginationModel } = fitlerMain;
    const { input, getData } = filterMainData;
    const { isLoadingDelete, closeModalDelete, closeSnackBarOpen, modal, snackbarOpen, column, row, detail, tableLoading, totalPages, closeMenu, optionMenu, handleOpenModalDelete } = useTable({ setIsChecked, selectedIds, setSelectedIds, isChecked, notGroupSelected, setNotGroupSelected, fitlerMain })

    const {
        closeOpenSnakbar,
        download,
        downloadCSV,
        downloadPDF,
        downloadWORD,
        getDetailInform,
        openSnackbar
    } = useDownloadWithUuid({
        getUuid: userGroupServiceFetch.getUuid,
        setUuid,
        uuid:uuid,
        docName: t('userGroup.text.optionGestion'),
        query: returnQueryWithPagination({ ...fitlerMain.query, filter: fitlerMain.query.filter?.replaceAll('+', '%2B') }, formatFilterMain),
        downloadFuntion: userGroupServiceFetch.generateSummary,
    })
    useEffect(() => {
        getData()
    }, [])

    useEffect(() => {
        if (uuid) {
            const interval = setInterval(() => {
                getDetailInform();
            }, 30000);
            return () => clearInterval(interval);
        }
    }, [uuid])

    return (
        <Box sx={styles.container}>
            <BreadCrumb removeBreadcrumb={['user']} />

            <Box sx={styles.header}>
                <Typography variant='title_grey_big'>{t('userGroup.titles.groupGestion')}</Typography>

                <Box sx={styles.flex}>
                    <LinearProgressDownload show={download} text={t('userGroup.text.generateDetailInform')} />

                    <Button variant="outlined" color="primary" onClick={handleOpenModalDelete}>
                        {t('filesManager.buttons.delete')}
                    </Button>

                    <ModelDownloadButtons
                        csv={downloadCSV}
                        pdf={downloadPDF}
                        word={downloadWORD}
                        disableCSV={download}
                        disablePDF={download}
                        disableWORD={download}
                        styleType
                    />

                    {!!counter &&
                        <Tooltip title={t('ToolTips.clearFilters')}>
                            <IconButton
                                sx={(styles.clean, (counter || 0) > 0 ? null : styles.hide)}
                                onClick={() => {
                                    cleanFilter()
                                }}
                            >
                                {icons('clean')}
                            </IconButton>
                        </Tooltip>
                    }

                    <Tooltip title={t('ToolTips.create')}>
                        <IconButton
                            sx={styles.clean}
                            onClick={() => { navigate('../create') }}
                        >
                            {icons('add')}
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box>

            <FiltersDrawer cleanFilter={cleanFilter} count={counter} right={0} top={50}>
                <Box sx={styles.section}>
                    <DinamicForm errors={errors} input={Object.values(input)} values={filterData} onChange={onChange} filter={true} />
                </Box>
            </FiltersDrawer>

            <CustomTable
                name="Informe General"
                serverSidePagination={{ page: paginationModel.page + 1, size: paginationModel.pageSize, totalPages: totalPages }}
                handleChange={(page: number, pageSize: number) => {
                    handlePagination({ page, pageSize })
                }}
                order={
                    query?.sort && {
                        count: query?.sort?.count,
                        key: query?.sort?.field,
                        order: query?.sort?.sort,
                    }
                }
                sortable={(field, sort, count) => {
                    sortTable(field && sort ? { field: field, sort: sort, count } : undefined)
                }}
                column={column as any}
                loader={tableLoading}
                row={row}
                selected={-1}
            />

            <BaseMenu
                sx={[styles.baseMenu, detail.positionMenu]}
                anchorEl={detail.anchor}
                setAnchorEl={closeMenu}
                menuItems={detail.menu}
                click={(item) => {
                    optionMenu({ item: item as Item })
                }}
            />

            <SnackSimple
                close={closeOpenSnakbar}
                open={openSnackbar.open}
                type={openSnackbar.type as Types}
                message={openSnackbar.message}
            />

            <SnackSimple open={snackbarOpen.open} close={closeSnackBarOpen} message={snackbarOpen.message} type={snackbarOpen.type} />

            <SimpleModal
                open={!!modal.open}
                next={modal.confirm}
                back={closeModalDelete}
                close={closeModalDelete}
                description={modal.description}
                buttonText={t('general.confirm')}
                cancelText={t('general.cancel')}
                title={modal.title}
                loadingButton
                isLoading={isLoadingDelete}
            />
        </Box>
    )
}